enum AddressType {
    SuggestedAddress = 'suggestedAddress',
    OriginalAddress = 'originalAddress',
}

export default AddressType;
